/* eslint-disable no-undef */
import PropTypes from 'prop-types'
import React from 'react'
import withTranslation from 'next-translate/withTranslation'
import Link from 'next/link'

import {
  RightColumnImages,
  // RightColumnOfferPrice,
  RightColumnShare,
  RightColumnVehicleRegistration
} from '../../../components'
import { getCurrentAd } from 'SRC/modules/ads/detail/selectors'
import { getUserInfo } from 'SRC/modules/users/Profile/selectors'
import Lightbox from 'react-images'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { ImageManager } from 'Core/imageManager'
import { getAdThumbnailUrl, getAdImageUrl } from 'SRC/modules/ads/shared/functions'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { AdImagesBanners } from '../../Banners'
import { EditAdButtons } from '../../EditAdButtons'

export class RightColumn extends React.Component {
  constructor(props) {
    super(props)

    this.vehicleRegistrationPrice = 682.08

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    }

    this.im = new ImageManager()
  }

  getVisibleImagesLength = () => this.props.ad ? this.props.ad.media.filter(item => item.visible).length : 0

  openLightbox = (index, event) => {
    event.preventDefault()
    this.setState(prevState => ({
      ...prevState,
      currentImage: index,
      lightboxIsOpen: true
    }))
  }

  closeLightbox = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: 0,
      lightboxIsOpen: false
    }))
  }

  goToPrevious = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: this.state.currentImage === 0 ? this.getVisibleImagesLength() - 1 : this.state.currentImage - 1
    }))
  }

  goToNext = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: this.state.currentImage === this.getVisibleImagesLength() - 1 ? 0 : this.state.currentImage + 1
    }))
  }

  goToImage = (index) => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: index
    }))
  }

  handleClickImage() {
    if (this.state.currentImage === this.getVisibleImagesLength() - 1) return
    this.goToNext()
  }

  getVisibleImages = () => this.props.ad.media && Array.isArray(this.props.ad.media)
    ? this.props.ad.media.filter(item => item.visible)
    : []

  getImagesForColumn = () => {
    const visibleImages = this.getVisibleImages()
    return visibleImages.length ? visibleImages.map(item => getAdImageUrl(item)) : null
  }

  getLightBoxImages = () => {
    const visibleImages = this.getVisibleImages()
    return visibleImages.length
      ? visibleImages.map(item => ({
        src: getAdImageUrl(item),
        thumbnail: getAdThumbnailUrl({ image: item })
      }))
      : null
  }

  getCustomControls = () => {
    return [
      <AdImagesBanners key='ad-images-banners' currentImage={this.state.currentImage} />,
      <div className='image-sides image-left' key='image-left' onClick={this.goToPrevious}>
        <div className='arrow arrow-left'>
          <div className='arrow_icon arrow-left_icon' />
        </div>
      </div>,
      <div className='image-sides image-right' key='image-right' onClick={this.goToNext}>
        <div className='arrow arrow-right'>
          <div className='arrow_icon arrow-right_icon' />
        </div>
      </div>,
      <div className='lightbox-custom-header' key='lightbox-custom-header'>
        <span>{`${this.state.currentImage + 1}/${this.getVisibleImagesLength()}`}</span>
        <span>{this.props.ad ? this.props.ad.titleCompiled : ''}</span>
      </div>,
      <span key='empty' />
    ]
  }

  getPromoEndDate = () => {
    const { ad} = this.props
    const listingDuration = ad?.listing === 2 ? 5 : ad?.listing === 3 ? 10 : 0
    let payedTo = null

    if (ad?.listingActivated && ad?.listing && listingDuration) {
      let listingActivatedDate = new Date(ad?.listingActivated)
      listingActivatedDate.setDate(listingActivatedDate.getDate() + listingDuration)
      payedTo = getFormatDate(listingActivatedDate.toISOString())

      return payedTo
    }

    return ''
  }

  render() {
    const lightboxImages = this.getLightBoxImages()
    const customControls = this.getCustomControls()

    const { i18n: { t } } = this.props

    console.log('this.props.ad', this.props.ad)

    const theme = {
      arrow__size__medium: {
        display: 'none'
      }
    }

    const adSeo = this.props.ad ? this.props.ad.seo : ''
    const adStatus = this.props.ad ? this.props.ad.status : ''
    const adListingStatus = this.props.ad ? this.props.ad.listingStatus : ''
    const adListingActivated = this.props.ad ? this.props.ad.listingActivated : ''

    const { registrationFormulas, isMyAd } = this.props
    const displayVehicleRegistration = registrationFormulas && Array.isArray(registrationFormulas) && registrationFormulas.length

    return (
      <div className='oglasi-info-right'>
        {
          lightboxImages
            ? <Lightbox
              currentImage={this.state.currentImage}
              images={lightboxImages}
              isOpen={this.state.lightboxIsOpen}
              onClickImage={this.handleClickImage}
              onClickNext={this.goToNext}
              onClickPrev={this.goToPrevious}
              onClose={this.closeLightbox}
              onClickThumbnail={this.goToImage}
              showThumbnails
              backdropClosesModal
              customControls={[customControls]}
              showCloseButton={false}
              theme={theme}
            />
            : null
        }
        <RightColumnImages ad={this.props.ad} onClick={this.openLightbox} length={this.getVisibleImagesLength()} />
        <RightColumnShare />
        {isMyAd ? <EditAdButtons /> : null}
        {displayVehicleRegistration
          ? <RightColumnVehicleRegistration price={this.props.ad.registrationCost ? this.props.ad.registrationCost.toFixed(2) : 0} /> : null}
      </div>
    )
  }
}

RightColumn.propTypes = {
  ad: PropTypes.shape({
    price: PropTypes.number.isRequired,
    titleCompiled: PropTypes.string.isRequired,
    oldPrice: PropTypes.number,
    priceType: PropTypes.number.isRequired,
    media: PropTypes.arrayOf(PropTypes.shape({
      fd: PropTypes.string,
      visible: PropTypes.bool
    })),
    registrationCost: PropTypes.number
  }).isRequired,
  isMyAd: PropTypes.bool.isRequired,
  registrationFormulas: PropTypes.array.isRequired
}

const mapStateToProps = state => {
  const ad = getCurrentAd(state)
  const user = getUserInfo(state)

  const adUserId = ad.user.id
  const userId = user ? user.id : null

  const isMyAd = adUserId === userId

  if (ad && ad.media && Array.isArray(ad.media)) {
    ad.media.sort((a, b) => a.priority - b.priority)
  }
  const category = getCurrentSubCategory(state)
  return {
    ad,
    isMyAd,
    registrationFormulas: category && category.registrationFormulas ? category.registrationFormulas : []
  }
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps)
)

export default enhance(RightColumn)
